<template>
    <div v-loading='loading' class="page page-home"
        :style="'background-image: url('+(actInfo.bgImg)+');background-color:'+bgColor+' '">
        <div class="pa btn-box">

            <div class="btn btn-chouhaoli" @click="getChoujiang"></div>
            <router-link :to="'/gui_ze?pic=' + actInfo.ruleImg" class="btn btn-rule"></router-link>

        </div>
        <!-- 最近中奖滚动信息 -->
        <div class="laba" v-if="lastWinNote.length"></div>
        <div class="msg">
            <el-carousel height="7vw" direction="vertical" loop>
                <el-carousel-item v-for="(item, index) in lastWinNote" :key="index">
                    <div class="small to">{{ item.subMobile }}抽中{{ item && item.giftName }}</div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 九宫格抽奖 -->
        <Choujiang :canRunCount="canRunCount" :giftList="actInfo.giftList" @handleResult="handleResult"></Choujiang>
        <!-- 任务列表 -->
        <div class="list" :style="'background-image: url(' + (actInfo.bgImg2) + ')'">
            <!-- <div class="list-item list-item-2 clearfix" v-if="fromPlat != 1">
                <img class="el pic" src="@/assets/image/n_yaoqing.png" alt="">
                <div class="el desc" v-if="fromPlat != 1">成功邀请一位好友参与活动，+1抽奖次数</div>
                <div class="el desc" v-else>邀请好友参与活动</div>
                <div class="el btnss button1 to" @click="onShare">邀请</div>
            </div> -->
            <div class="list-item clearfix" v-for="(item, index) in actInfo && actInfo.taskList" :key='index'>
                <img class="el pic" :src="item.icon || default_icon" alt="">
                <div class="el desc">
                    <div class="el desc">
                        <div class="desc-title">
                            {{ item && item.name }}
                        </div>
                        <div class="desc-detail">
                            {{ item && item.text }}
                        </div>
                    </div>
                </div>
                <div v-if="item.isFinish" class="el btnss btn-finish to" @click="onGoTo(item)">{{ item && item.btnText
                }}</div>
                <div v-else class="el btnss  to" @click="onGoTo(item)">{{ item && item.btnText }}</div>
            </div>
        </div>
        <div class="footer" :style="'background-image: url(' + (actInfo.bgImg3) + ')'">

        </div>

        <!-- <router-link  to="/pai_hang_bang" class="btn btn-paihangbang">排行榜</router-link> -->
        <!-- <div class="logout" @click="logout">退出登陆</div> -->
        <!-- <div class="mod"> -->
        <!-- 用户信息 -->
        <!-- <div class="userinfo">
                <img :src="userInfo.avatar || default_user" alt="" class="pic ">
                <div class="boxxxx">
                    <div class="line1">用户名: {{ userInfo.nickName }}</div>
                    <div class="line2 to">等级: <i style="padding-right: 5px">{{ userInfo.levelName }}</i> 分数:
                        <i>{{ userInfo.score }}</i>
                    </div>
                </div>
            </div> -->
        <!-- <div class="da-ti" @click="onDatiTip">开始答题</div>
            <div class="da-ti-num">剩余答题次数：{{ daTiNum }}次</div>
            <img src="@/assets/image/n_task.png" class="list-title" alt=""> -->
        <!-- 任务list -->
        <!-- <div class="list">
                <div class="list-item list-item-2 clearfix" v-if="fromPlat != 1">
                    <img class="el pic" src="@/assets/image/n_yaoqing.png" alt="">
                    <div class="el desc" v-if="fromPlat != 1">成功邀请一位好友参与活动，+1抽奖次数</div>
                    <div class="el desc" v-else>邀请好友参与活动</div>
                    <div class="el btnss button1 to" @click="onShare">邀请</div>
                </div>
                <div class="list-item clearfix" v-for="(item, index) in actInfo && actInfo.taskList" :key='index'>
                    <img class="el pic" :src="item.icon || default_icon" alt="">
                    <div class="el desc">
                        <div class="el desc">
                            <div class="desc-title">
                                {{ item && item.text }}
                            </div>
                            <div class="desc-detail">
                                {{ item && item.text }}
                            </div>
                        </div>
                    </div>
                    <div class="el btnss button1 to" @click="onGoTo(item && item.link, item && item.taskId)">{{ item &&
                            item.btnText
                    }}</div>
                </div>
            </div> -->
        <!-- </div> -->


        <!-- 成功邀请提示 -->
        <el-dialog :visible.sync="dialogYaoqing" width="100%" custom-class='el-dialog-no-header'>
            <div class="pop-box pr">
                <div class="title pa">恭喜您</div>
                <div class="desc pa">已成功邀请{{ userInfo.addCount }}位好友，抽奖次数</div>
                <div class="num pa">+{{ userInfo.addCount }}</div>
                <img src="@/assets/image/n_p1.png" class="tipsss pa" alt="">
                <div class="descsss pa">话费奖品将于活动结束后的次月底前充值至您<br />注册账号所用手机号码中</div>
                <div class="button1 pop-btn pa" @click="dialogYaoqing = false">邀请更多好友</div>
                <div class="close pa" @click="dialogYaoqing = 0"></div>
            </div>

        </el-dialog>


        <!-- new -->
        <!-- 今日的抽奖次数已经用完 -->
        <el-dialog :visible.sync="dialogToadyNo" width="80%" custom-class='el-dialog-no-header' :show-close="false">
            <div class="pop-box-dati pop-nonum">
                <!-- <div class="pop-title">恭喜您 抽中</div> -->

                <div class="tip-text">今日的抽奖次数已经用完啦， <br />
                    快去公众号看看其他活动吧！</div>

                <div class="btnss" @click="dialogToadyNo = false">确定</div>
                <div class="close" @click="dialogToadyNo = false"></div>

            </div>
        </el-dialog>
        <!-- 未中奖 -->
        <el-dialog :visible.sync="dialogNoprize" width="80%" custom-class='el-dialog-no-header' :show-close="false">
            <div class="pop-box-dati pop-noPrize">
                <!-- <div class="pop-title">很遗憾</div> -->

                <div class="tip-text">本次未中奖 <br />
                    请再接再厉哦～</div>

                <div class="btnss" @click="dialogNoprize = false">确定</div>
                <div class="close" @click="dialogNoprize = false"></div>

            </div>
        </el-dialog>

        <!-- 转发 -->
        <el-dialog :visible.sync="dialogZhuanfa" width="80%" custom-class='el-dialog-no-header' :show-close="false">
            <div class="pop-box-dati pop-zhuanfa">
                <!-- <div class="pop-title">转发成功</div> -->

                <div class="tip-text">抽奖次数 <br />
                    <i>+{{ rewardNum }}</i>次
                </div>

                <div class="btnss" @click="dialogZhuanfa = false">快去抽奖吧</div>
                <div class="close" @click="dialogZhuanfa = false"></div>

            </div>
        </el-dialog>

        <!-- 抽奖记录-->
        <el-dialog :visible.sync="dialogPrizelist" width="80%" custom-class='el-dialog-no-header' :show-close="false">
            <div class="pop-box-dati pop-prizelist">
                <!-- <div class="pop-title">中奖记录</div> -->
                <div class="prize-list-title">
                    <div>
                        手机号
                    </div>
                    <div>
                        奖品
                    </div>
                </div>
                <div class="prize-list">
                    <div class="prize-list-item" v-for="(item, index) in choujianglist" :key="index">
                        <div class="prize-phone" v-if="item.mobile == '未填写'" @click="showPrizeSubMobile(item)">{{
                                item.mobile
                        }}</div>
                        <div class="prize-name to" v-if="item.mobile == '未填写'" @click="showPrizeSubMobile(item)">{{
                                item.giftName
                        }}</div>
                        <div class="prize-phone" v-if="item.mobile != '未填写'">{{
                                item.mobile
                        }}</div>
                        <div class="prize-name to" v-if="item.mobile != '未填写'">{{
                                item.giftName
                        }}</div>


                    </div>
                </div>
                <div class="close" @click="dialogPrizelist = false"></div>
            </div>
        </el-dialog>

        <!-- 中奖实物 -->
        <el-dialog :visible.sync="dialogChouzhongShiwu" width="80%" custom-class='el-dialog-no-header'
            :show-close="false">
            <div class="pop-box-dati pop-zhongjiang1">
                <!-- <div class="pop-title">恭喜您 抽中</div> -->
                <div class="tip-text tip-text-name">{{ currentPrize.name }}</div>
                <div class="prize-pic" :style="'background-image:url(' + currentPrize.img + ')'">
                </div>
                <div class="input-boxs">
                    <div class="label">手机号</div>
                    <div class="inpp">
                        <input type="text" v-model="mobile">
                    </div>
                </div>
                <div class="tip-text tip-text1">
                    <!-- 请提交您的手机号，我们会在10个工作日内联系您，进行奖品发放 -->
                </div>

                <div class="btnss" @click="submitMsg">提交</div>
                <div class="close" @click="dialogChouzhongShiwu = false"></div>

            </div>
        </el-dialog>
        <!-- 中奖虚拟 -->
        <el-dialog :visible.sync="dialogChouzhongXuni" width="80%" custom-class='el-dialog-no-header'
            :show-close="false">
            <div class="pop-box-dati pop-zhongjiang1">
                <div class="pop-title">恭喜您 抽中</div>
                <div class="tip-text tip-text-name">{{ currentPrize.name }}</div>
                <div class="prize-pic">
                    <img :src="currentPrize.img" alt="">
                </div>
                <div class="input-boxs">
                    <div class="label">手机号</div>
                    <div class="inpp">
                        <input type="text" v-model="mobile">
                    </div>
                </div>
                <div class="tip-text tip-text1">
                    <!-- 请提交您的手机号，我们会在10个工作日内，进行奖品发放 -->
                </div>

                <div class="btnss" @click="submitMsg">提交</div>
                <div class="close" @click="dialogChouzhongXuni = false"></div>

            </div>
        </el-dialog>
        <!-- 补充提交手机号 -->
        <el-dialog :visible.sync="dialogChouzhongXuni1" width="80%" custom-class='el-dialog-no-header'
            :show-close="false">
            <div class="pop-box-dati pop-zhongjiang1 pop-zhongjiang3">
                <div class="pop-title">提交手机号</div>
                <div class="tip-text tip-text-name">{{ currentPrize.name }}</div>
                <div class="prize-pic">
                    <img :src="currentPrize.img" alt="">
                </div>
                <div class="input-boxs">
                    <div class="label">手机号</div>
                    <div class="inpp">
                        <input type="text" v-model="mobile">
                    </div>
                </div>
                <div class="tip-text tip-text1">
                    <!-- 请提交您的手机号，我们会在10个工作日内，进行奖品发放 -->
                </div>

                <div class="btnss" @click="submitMsg">提交</div>
                <div class="close" @click="dialogChouzhongXuni1 = false"></div>

            </div>
        </el-dialog>

        <!-- 登录 -->
        <el-dialog :visible.sync="dialogLogin" width="80%" custom-class='el-dialog-no-header' :show-close="false"
            :close-on-click-modal="false">
            <div class="pop-box-dati pop-zhongjiang1">
                <!-- <div class="pop-title">登录</div> -->
                <div class="pop-title"></div>
                <div class="tip-text tip-text-name">{{ currentPrize.name }}</div>
                <div class="prize-pic">
                    <img :src="currentPrize.img" alt="">
                </div>
                <div class="input-boxs input-boxs-phone">
                    <div class="label">手机号</div>
                    <div class="inpp">
                        <input type="text" v-model="mobile">
                    </div>
                </div>
                <div class="input-boxs input-boxs-sms">
                    <div class="label">验证码</div>
                    <div class="inpp">
                        <input type="text" v-model="sms">
                    </div>
                    <div :class="['sendSms', sendSmsAllow ? '' : 'sendSmsDisabled']" @click="sendSms">{{
                            sendSmsText
                    }}</div>
                </div>
                <div class="input-boxs goto-register">
                    <span>还没有账号？</span>
                    <span class="reg-text" @click="onGoToRegister">点击注册</span>
                </div>
                <div class="input-boxs goto-guize">
                    <div class="label"><el-checkbox v-model="checked"></el-checkbox></div>
                    <div class="inpp">
                        <span class="rule-txt">参与活动即表示了解并遵守</span>
                        <span @click="gotoRule('/gui_ze?pic=' + actInfo.ruleImg)"
                            class="rule-btn">活动规则</span></div>
                </div>


                <div class="btnss" @click="submitLogin">登录</div>
                <!-- <div class="close" @click="dialogLogin = false"></div> -->

            </div>
        </el-dialog>

        <share ref="share" :taskId="shareTaskId" @handleShareSucc="shareSucc" />

    </div>

</template>

<script>

import api from '@/assets/js/api'
import appENV from '@/assets/js/env'
import { cookie, queryString } from '@/assets/js/utils'
import Share from '../share.vue'
import Choujiang from './choujiang.vue'
export default {
    name: "notice",
    data () {
        return {
            checked: false,
            firstActivated: true,//是否首次执行activated事件
            mobile: '',
            rewardNum: 0, // 转发奖励抽奖的次数
            canRunCount: 0,
            dialogPrizelist: false, // 中奖记录
            dialogToadyNo: false, // 今日抽奖次数用完
            dialogNoprize: false, // 未中奖
            dialogZhuanfa: false, // 转发
            dialogChouzhongShiwu: false, // 抽中奖品实物
            dialogChouzhongXuni: false, // 抽中奖品虚拟
            dialogChouzhongXuni1: false, // 补充提交手机号
            dialogLogin: false, // 登录
            sms: '', // 短信验证码
            requestNo: 0, // 短信验证码请求编号
            tt: {},
            sendSmsText: '发送',
            sendSmsAllow: true,
            sendSmsTime: 60,
            currentPrize: {}, // 抽中的奖品
            lastWinNote: [], // 最新中奖滚动信息
            shareTaskId: 0, //分享任务ID
            msgList: [
                // '我的中国心我的中国心我的中国心我的中国心我的中国心',
                // '我的中国心我的中国心我的中国心我的中国心我的中国心',
                // '我的中国心我的中国心我的中国心我的中国心我的中国心',
                // '我的中国心我的中国心我的中国心我的中国心我的中国心',
                // '我的中国心我的中国心我的中国心我的中国心我的中国心',
            ],

            actId: (window && window.actId),
            canSubmitLogin: true,
            loading: false,
            registerLink: '',
            showCloseBtn: false,// 弹窗-显示关闭按钮
            dialogDatiTipNo: false, // 没有答题次数了
            dialogDatiTip: false,// 弹窗-开始答题提示
            dialogYaoqing: false,// 弹窗-邀请
            dialogActiveNo: false, // 弹窗-活动未开始
            userInfo: {},
            default_icon: require('../../assets/image/home-btn-ji.png'),
            default_user: require('../../assets/image/default_user.png'),
            bgColor: "#b71a23",
            daTiNum: 1,// 剩余答题次数
            time3s: 3, // 进入答题倒计时
            phone: '',
            pwd: '',
            choujianglist: [],// 抽奖记录
            actInfo: {
                bgImg: require('../../assets/image/n_pg.jpg'),
                bgImg2: require('../../assets/image/n_pg1.png'),
                bgImg3: require('../../assets/image/n_pg2.png'),
                ruleImg: require('../../assets/image/n_rule.jpg'),
                giftList: [
                    {
                        title: 1,
                        activeIndex: 1,
                        content: '谢谢惠顾1',
                        pic: require('../../assets/image/n14.png')
                    },
                    {
                        title: 2,
                        activeIndex: 2,
                        content: '一等奖',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 3,
                        activeIndex: 3,
                        content: '谢谢惠顾',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 8,
                        activeIndex: 8,
                        content: '谢谢惠顾',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 0,
                        activeIndex: 0,

                    },
                    {
                        title: 4,
                        activeIndex: 4,
                        content: '三等奖',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 7,
                        activeIndex: 7,
                        content: '谢谢惠顾',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 6,
                        activeIndex: 6,
                        content: '二等奖',
                        pic: require('../../assets/image/n14.png')

                    },
                    {
                        title: 5,
                        activeIndex: 5,
                        content: '谢谢惠顾',
                        pic: require('../../assets/image/n14.png')

                    },
                ],
                taskList: [
                    {
                        text: '点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴',
                        link: '',
                        desc: '点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴点点滴滴',
                        taskId: '',
                        isFinish: true,
                        btnText: '完成',
                        icon: require('../../assets/image/n_pg.jpg')
                    },
                    {
                        text: 'eeeeee',
                        link: '',
                        isFinish: false,
                        taskId: '',
                        btnText: '查看',
                        icon: require('../../assets/image/n_pg.jpg')
                    },
                    {
                        text: 'eeeeee',
                        link: '',
                        taskId: '',
                        icon: require('../../assets/image/n_pg.jpg')
                    }
                ]
            },
            fromPlat: 0,
            query: this.$route.query,
        }
    },


    methods: {
        gotoRule (url) {
            this.dialogLogin = false;
            this.$router.push(url);
        },
        onGetUserinfo () {

        },
        // 页面加载
        async onload () {
            // this.$message({
            //     message: '提交成功，即将开始答题！',
            //     type: 'success'
            // });
            let self = this;
            self.checkRegisterCbk() // 检测是否为注册成功回调，进行处理
            self.onGetTask();
            self.onGetUserinfo();

            self.fromPlat = await appENV.catch(err => {
                // console.log(err)
            })

            // 中行
            if (self.fromPlat == 2) {
                self.onZhonghangReload();
            }

            let idx = location.href.indexOf('?');
            if (idx > 0) {
                let query = location.href.substr(idx);
                // 用户如果携带query参数进入页面，则将其query参数整个字符串保存在cookie中，随浏览器关闭失效
                if (query && query.length > 1) {
                    cookie.set('query' + self.actId, query)
                }
            }



        },
        // 检测是否为注册成功回调，进行处理
        async checkRegisterCbk () {// mobile 和 custId
            let self = this;
            let token = cookie.get('token' + self.actId);
            if (token) {//已登录不处理
                return;
            }
            if (self.$route.query && self.$route.query.mobile && self.$route.query.custId && self.$route.query.sign) {
                let res = await api({
                    method: 'getToken',
                    mobile: self.query && self.query.mobile,
                    custId: self.query && self.query.custId,
                    sign: self.query && self.query.sign,
                    fromSource: cookie.get('query' + self.actId) || '',
                }).catch(err => {
                    // console.log(err)
                })
                let { data, code, msg } = res && res.data;
                // console.log(data, code ,msg)
                // hasReward
                if (code == 200) {
                    self.shareKey = data.shareKey;
                    cookie.set('token' + self.actId, data.token, 90);
                    cookie.set('shareKey' + self.actId, data.shareKey, 90);
                    let t = setTimeout(() => {
                        clearTimeout(t);
                        self.onGetUserinfo();
                    }, 50)
                    self.dialogLogin = false;
                }
                if (code == 199) {
                    self.onShowLoginPop();
                }


            }
        },

        // 中行app中，如果当前用户已登录(token已存在)并且url未携带分享参数
        // 或者携带的分享参数和当前登录用户保存在本地的 shareKey 不同，
        // 则将页面地址重置为 活动首页地址 + 当前用户shareKey
        onZhonghangReload () {
            let self = this;
            let token = cookie.get('token' + self.actId);
            // alert(token);
            if (!token) {
                self.onShowLoginPop();
                return false;
            }
            if (self.$route && self.$route.query && self.$route.query.__sk
                && self.$route.query.__fok && self.$route.query.__sa) {
                let urlShareKey = '?__sk=' + self.$route.query.__sk
                    + '&__fok=' + self.$route.query.__fok
                    + '&__sa=' + self.$route.query.__sa;
                let shareKey = cookie.get('shareKey' + self.actId);
                if (urlShareKey !== shareKey) {
                    // alert(urlShareKey);
                    // alert(shareKey);
                    // alert('1= '+self.$refs['share'].getShareUrl());
                    location.href = self.$refs['share'].getShareUrl();
                    return true;
                }
            } else {
                // alert('2= '+self.$refs['share'].getShareUrl());
                location.href = self.$refs['share'].getShareUrl();
                return true;
            }
            return false;
        },

        /**
         * 任务列表，点击跳转
         * @param { }
         */
        async onGoTo (item) {
            if (!item.taskId) {
                return;
            }
            let self = this;
            let token = cookie.get('token' + self.actId);
            if (!token) {
                self.onShowLoginPop();
                return;
            }
            self.loading = true;
            if (item.type == 1) {
                self.onShare(item.taskId); // 分享任务
            } else {
                // 点击任务
                let res = await api('post', '/finishTask', {
                    token,
                    taskId: item.taskId
                }).catch(err => {
                    self.loading = false;

                })
                let { data, code, msg } = res && res.data;
                if (code == 200) {
                    self.getCanRunCount(() => {
                        self.loading = false;
                        if (item.link.includes('.jpeg') || item.link.includes('.png') || item.link.includes('.jpg') || item.link.includes('.gif')) {
                            self.$router.push('/gui_ze?pic=' + link)
                        } else {
                            window.location.href = item.link
                        }
                    });
                }
            }

            self.loading = false;
        },

        /**
         * 显示登陆弹窗
         * @param { }
         */
        onShowLoginPop () {
            this.dialogLogin = true;
        },

        /** 
         * 封装分享包含微信、中银
        */
        onShare (taskId) {
            this.$refs['share'].share({}, taskId);
        },

        // 分享成功回掉
        shareSucc () {
            let self = this;
            self.getCanRunCount();
            let rewardNum = cookie.get('rewardNum');
            let needShowPrizePop = cookie.get('needShowPrizePop');
            if (Number(needShowPrizePop)) {
                self.dialogZhuanfa = true;
                self.rewardNum = rewardNum;
                cookie.set('needShowPrizePop', 0);
            }
        },

        /** 
         * 跳转注册页
        */
        onGoToRegister () {
            // 中银注册页面地址
            // var regUrl = 'http://m.bocim.com/zyfund_temp/zyh5/index.html#/app/register?type=otherActivity&notifyUrl='; //灰度
            var regUrl = 'http://m.bocim.com/zyfund/zy/index.html#/app/register?type=otherActivity&notifyUrl='; //生产
            window.location.href = regUrl + encodeURI(window.location.href.split('#')[0]);
        },

        /**
         * 登录
         * @param { }
         */
        async submitLogin () {
            let self = this;
            let reg = /^1[0-9]{10}$/;
            let regSms = /^[0-9]\d+$/;
            if (!reg.test(self.mobile)) {
                self.$message.error("请输入正确的手机号");
                return false;
            }
            if (!regSms.test(self.sms)) {
                self.$message.error("验证码格式错误，请核对");
                return false;
            }
            let res = await api('post', '/smsLogin', {
                mobile: self.mobile,
                code: self.sms,
                requestNo: self.requestNo,
            }).catch(err => {
                // console.log(err)
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {
                self.dialogLogin = false;
                cookie.set('token' + self.actId, data.token, 90);
                cookie.set('shareKey' + self.actId, data.shareKey, 90);
                self.$message.success("登录成功");
                self.getCanRunCount();
            } else {
                self.$message.error("登录失败，请重试");
            }
            self.sms = '';
            clearInterval(self.tt);
            setTimeout(() => {
                self.sendSmsText = '发送';
                self.sendSmsAllow = true;
            }, 1000)



        },

        /**
         * 发送登录的短信验证码
         * @param { }
         */
        async sendSms () {
            let self = this;
            let reg = /^1[0-9]{10}$/;
            if (!this.checked) {
                self.$message.warning("勾选了解并遵守活动规则后才能参与活动");
                return false;
            }
            if (!reg.test(self.mobile)) {
                self.$message.error("请输入正确的手机号");
                return false;
            }

            if (!self.sendSmsAllow) {
                self.$message.warning("验证码已发送，请耐心等待");
                return false;
            }
            self.sendSmsAllow = false;
            self.sendSmsText = '发送中..';
            let res = await api('post', '/sendSms', {
                mobile: self.mobile
            }).catch(err => {
                // console.log(err)
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {
                self.requestNo = data.requestNo;
                let time = self.sendSmsTime;
                self.tt = setInterval(() => {
                    if (time <= 0) {
                        self.sendSmsText = '发送';
                        self.sendSmsAllow = true;
                        clearInterval(self.tt);
                    } else {
                        time--;
                        self.sendSmsText = time + 's';
                    }

                }, 1000);
                self.$message.success("验证码发送成功");
            } else {
                self.$message.warning("验证码发送失败");
                self.sendSmsText = '发送';
                self.sendSmsAllow = true;
            }
        },

        /**
         * 提交中奖信息
         * @param { }
         */
        async submitMsg () {
            let self = this;
            let reg = /^1[0-9]{10}$/;
            if (!reg.test(self.mobile)) {
                self.$message.error("请输入正确的手机号");
                return false;
            }
            let res = await api('post', '/subMobile', {
                mobile: self.mobile,
                winId: self.currentPrize.winId
            }).catch(err => {
                // console.log(err)
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {
                self.dialogChouzhongShiwu = false;
                self.dialogChouzhongXuni = false;
                self.dialogChouzhongXuni1 = false;
                self.$message.success("中奖信息提交成功");
                self.getlastWinNote();
                self.getChoujiang();
            }
        },

        showPrizeSubMobile (item) {
            let self = this;
            item.winId = item.noteId;
            self.currentPrize = item;
            this.dialogChouzhongXuni1 = true;
        },
        /**
         * 获取抽奖记录
         * @param { }
         */
        async getChoujiang () {
            let self = this;
            let res = await api('get', '/myRunNote', {
                pageNo: 1,
                pageSize: 2000
            }).catch(err => {
                // console.log(err)
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {
                self.dialogPrizelist = true;
                self.choujianglist = data.items;
            }
        },

        /**
         * 获取最近抽奖信息滚动
         * @param { }
         */
        async getlastWinNote () {
            let self = this;
            let res = await api('get', '/lastWinNote').catch(err => {
                // console.log(err)
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {
                self.lastWinNote = data;
            } else {
                self.lastWinNote = [];
            }
        },


        /**
         * 获取活动配置信息
         * @param { }
         */
        async getPageData () {
            let self = this;
            let res = await api('get', '/actData').catch(err => {
            })
            let { data, code, msg } = res && res.data;

            if (code == 200) {
                self.actId = data.actId;
                window.actId = data.actId;
                self.loginByCode();
                self.getlastWinNote(); // 滚动轮播中奖记录
                cookie.set('fromPlat', 1);
                for (const key in data) {
                    if (Object.hasOwnProperty.call(data, key)) {
                        const _value = data[key];
                        if (_value) {
                            if (key == 'giftList') {
                                // 奖品类型 0=空奖 1=实物 2=话费 3=积分 private int type;
                                let _val = _value;
                                let arr = [];
                                arr[0] = _val[0];
                                arr[1] = _val[1];
                                arr[2] = _val[2];
                                arr[3] = _val[7];
                                arr[4] = { giftId: 0 };
                                arr[5] = _val[3];
                                arr[6] = _val[6];
                                arr[7] = _val[5];
                                arr[8] = _val[4];
                                // value.splice(4, 0, {
                                //     giftId: 0,
                                // })

                                self.actInfo[key] = arr;

                            } else {
                                self.actInfo[key] = _value;
                            }
                        }

                    }
                }
                if(data.taskList && data.taskList.length){
                    for(var i=0;i<data.taskList.length;i++){
                        if(data.taskList[i].type == 1){//分享任务
                            self.shareTaskId = data.taskList[i].taskId;
                            break;
                        }
                    }
                }

            }
        },
        /** 
         * 抽奖后处理
         * @param { }
         */
        handleResult (data) {
            let self = this;
            // 奖品类型 0=空奖 1=实物 2=话费 3=积分 private int type;
            self.canRunCount = data.canRunCount;
            // dialogToadyNo
            if (data == 0) {
                self.dialogToadyNo = true;
            } else if (data.type == 0) {
                self.dialogNoprize = true;
            } else if (data.type == 1) {
                self.dialogChouzhongShiwu = true;
            } else if (data.type == 2 || data.type == 3) {
                self.dialogChouzhongXuni = true;
            }
            self.currentPrize = data;
        },

        /**
         * 查询可抽奖次数
         * @param { }
         */
        async getCanRunCount (succCbk) {

            let self = this;
            let res = await api('post', '/canRunCount', {
            }).catch(err => {
            })
            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            if (code == 200) {

                self.canRunCount = data.canRunCount;
                succCbk && succCbk();
            }
        },

        /**
         * 登录 by token
         * @param { }
         */
        async loginByToken (succCbk) {
            let self = this;
            let token = cookie.get('token' + self.actId);
            if (token) {
                let res = await api('post', '/userInfo', {
                }).catch(err => {
                    // console.log(err)
                })
                let { data, code, msg } = res && res.data;
                if (code == 200) {
                    self.canRunCount = data.canRunCount;
                    self.dialogLogin = false;
                    succCbk && succCbk();
                } else {
                    if (code == 199) {//返回未登录状态，需要清空缓存token信息
                        cookie.set('token' + self.actId, '', -1);
                    }
                    // self.$message.warning('登录失败');
                    self.dialogLogin = true;
                }
            } else {
                // self.$message.warning('未登录');
                self.dialogLogin = true;
            }

        },

        /**
         * 登录by wx code
         * @param { String } wx code字符串
         */
        async loginByCode (succCbk) {
            let self = this;
            self.loginByToken(succCbk);
        }



    },
    created () {
    },
    activated () {
        let self = this;
        let token = cookie.get('token' + self.actId);
        if (!token) {
            self.onShowLoginPop();
        }
        if (!self.firstActivated) {//非首次执行此事件需要刷新抽奖次数
            self.getCanRunCount();
        } else {
            self.firstActivated = false;
        }

        let rewardNum = cookie.get('rewardNum');
        let needShowPrizePop = cookie.get('needShowPrizePop');
        if (Number(needShowPrizePop)) {
            self.dialogZhuanfa = true;
            self.rewardNum = rewardNum;
            cookie.set('needShowPrizePop', 0);
        }
    },

    destroyed () {
        let self = this;
        window.removeEventListener('popstate', self.goBack, false);
    },
    mounted () {
        let self = this;
        self.actId = (self.query && self.query.__sa) || (window && window.actId);
        self.getPageData();

        this.$refs['share'].init();


        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', self.goBack, false);
        }
    },
    components: {
        Share,
        Choujiang
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import './index.less';
</style>